<script setup lang="ts">
const { t } = useTexts();

useSeo({
  title: t('account.wallet.last_withdraw.title'),
});
</script>

<template>
  <UserAccountPageLayout
    on-back="user-wallet"
    :title="$t('account.wallet.last_withdraw.title')"
  >
    <div :class="$style.walletTransactions">
      <UserWalletTransactions show-only-this-tab="withdrawals" />
    </div>
  </UserAccountPageLayout>
</template>

<style module lang="scss">
.walletTransactions {
  @apply w-full h-auto m-0 max-w-[792px];
}
</style>
